app.component("insuranceSummary", {
	templateUrl: "app/src/js/components/insuranceSummary/insuranceSummary.html",
	bindings: {
		patient: "<",
	},
	controller: [
		"Insurance",
		function (Insurance) {
			var $ctrl = this;
			var MAX_CHIPS = 2;
			var MAX_OTHER_NAME = 15;
			// Four states, three of which are answers and so carry colour; the fourth is the
			// absence of an answer and stays neutral grey.
			//
			// Self-paid is the brand's $yellow-cta. It was picked against the other two rather than
			// by eye: it is the furthest of the brand colours from both navy and cyan, and the only
			// candidate that stays clearly separable from cyan under deuteranopia and protanopia -
			// $green in particular collapses into cyan for those. 7.3:1 on its text, which is the
			// strongest of the four, and it reads as "money out of pocket" rather than as a warning.
			var PUBLIC_STYLE = { background: "#00bcd4", color: "#06303a" };
			var PROVIDER_STYLE = { background: "#0035d2", color: "#ffffff" };
			var SELF_PAID_STYLE = { background: "#ffab00", color: "#3d2900" };
			var NONE_STYLE = { background: "#e9edf3", color: "#5b6576" };

			// A free-text insurer name can be any length, so keep the chip to a
			// predictable width. The full name stays available as the chip's tooltip.
			function shorten(name) {
				if (name.length <= MAX_OTHER_NAME) {
					return name;
				}
				return name.slice(0, MAX_OTHER_NAME).replace(/\s+$/, "") + "\u2026";
			}

			function label(value, patient, full) {
				var name = patient.otherInsuranceName;
				return Insurance.providerName(value, (name && !full) ? shorten(name) : name);
			}

			// `title` carries the untruncated text, so a shortened chip stays readable on hover.
			function chip(text, style, full) {
				return { label: text, title: full || text, style: style };
			}

			function rank(style) {
				if (style === PUBLIC_STYLE) {
					return 0;
				}
				return style === SELF_PAID_STYLE ? 1 : 2;
			}

			function rebuild() {
				var patient = $ctrl.patient || {};

				// Every recorded value gets a chip, including the "no insurance" marker - that is
				// an answer the user gave and the header has to show it, distinctly from a record
				// nobody has filled in yet.
				var items = (patient.insuranceProviders || [])
					.map(function (value) {
						var name = label(value, patient, false);
						if (!name) {
							return null;
						}
						var style = PROVIDER_STYLE;
						if (value === Insurance.PUBLIC) {
							style = PUBLIC_STYLE;
						} else if (value === Insurance.NONE) {
							style = SELF_PAID_STYLE;
						}
						return chip(name, style, label(value, patient, true));
					})
					.filter(function (item) { return !!item; });

				// Only MAX_CHIPS fit, so the two that decide who gets billed come first: Public,
				// which reads as the funder rather than an insurer, then self-paid. The sort is
				// stable, so the remaining insurers keep the order they were recorded in.
				items.sort(function (a, b) {
					return rank(a.style) - rank(b.style);
				});

				if (items.length === 0) {
					items = [chip("No insurance set", NONE_STYLE)];
				}

				$ctrl.chips = items.slice(0, MAX_CHIPS);
				$ctrl.hidden = items.slice(MAX_CHIPS);
				$ctrl.extra = $ctrl.hidden.length;
			}

			// The multiselect mutates insuranceProviders in place, so the object reference
			// never changes and $onChanges alone would leave these chips stale.
			$ctrl.$onInit = rebuild;
			$ctrl.$onChanges = rebuild;
			$ctrl.$doCheck = function () {
				var providers = ($ctrl.patient && $ctrl.patient.insuranceProviders) || [];
				var stamp = providers.join(",") + "|" + (($ctrl.patient || {}).otherInsuranceName || "");
				if (stamp !== $ctrl.stamp) {
					$ctrl.stamp = stamp;
					rebuild();
				}
			};
		},
	],
});
